import { IShiftEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { ShiftMemberDateInfo, ShiftsByMemberAndDateStore } from "sh-conflict-store";

export default mutatorAction('SET_SHIFTID_TO_MEMBERDATEID_MAP', function setShiftIdToMemberDateIdsMap(shift: IShiftEntity, shiftMemberDateInfo: ShiftMemberDateInfo) {
    // update the memberDateIdToShiftId map to add the memberId + dateinterval for the new shift id.
    ShiftsByMemberAndDateStore().shiftIdToMemberDateIdsMap.set(shift.id, shiftMemberDateInfo);
});
